import { Component, OnInit, Input } from '@angular/core';
import { FeedMetadataColumn } from '../shared/models/feed-metadata-column.model';
import { ColumnFormatBoolean } from '../shared/models/column-format-boolean.model';


@Component({
  selector: '[feed-grid-row]',
  templateUrl: './feed-grid-row.component.html',
  styleUrls: ['./feed-grid-row.component.css']
})
export class FeedGridRowComponent implements OnInit {
    @Input() feedColumns: FeedMetadataColumn[];
    @Input() feedRow: any;

    constructor() { }

    ngOnInit() {
    }

    isNumber(value: string): boolean {
        const number = parseFloat(value);
        return !isNaN(number);
    }
    displayCheckIcon(value: boolean, columnFormat: ColumnFormatBoolean): boolean {
        return (columnFormat.format.toLowerCase() === 'icon'
            || columnFormat.format.toLowerCase() === null
            || columnFormat.format.toLowerCase() === '')
            && value;
    }
    getBoolValue(value: string, columnFormat: ColumnFormatBoolean): string {
        switch (columnFormat.format.toLowerCase()) {
            case 'yn':
                return value ?  'Yes' : 'No';
            case 'oo':
                return value ? 'On' : 'Off';
            default:
                return value ? 'True' : 'False';

        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-grid-row/feed-grid-row.component.ts